<template>
  <header id="mainHeader" class="l-mainHeader">
    <div class="l-mainHeader__leftWrapper">
      <div class="l-mainHeader__serviceLogoWrapper">
        <router-link to="/master_writer">
          <img
            class="l-mainHeader__serviceLogo"
            :src="logoSrc()"
            alt="b-master"
          />
        </router-link>
      </div>
      <div class="l-mainHeader__gMenuWrapper">
        <div
          v-for="(item, index) in globalMenuItems"
          :key="index"
          class="l-mainHeader__gMenuItem"
        >
          <router-link
            v-if="index == 0"
            :to="item.router"
            exact-active-class="active"
          >
            <v-icon>{{ item.icon }}</v-icon>
            <span>{{ item.text }}</span>
          </router-link>
          <router-link v-else :to="item.router" active-class="active">
            <v-icon>{{ item.icon }}</v-icon>
            <span>{{ item.text }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="l-mainHeader__rightWrapper">
      <router-link :to="{ name: 'masterWriterSystemInformations' }">
        <v-icon color="grey lighten-1">mdi-lightning-bolt</v-icon>
      </router-link>
      <a href="https://support.b-cms.jp" target="_blank" class="mx-2">
        <v-icon color="grey lighten-1"> mdi-help-circle-outline </v-icon>
      </a>

      <v-menu
        v-model="accountMenu"
        :close-on-content-click="false"
        :nudge-width="100"
        offset-y
        content-class="elevation-1"
      >
        <template v-slot:activator="{ on }">
          <div class="ma-2 p-accountIcon" v-on="on">
            <div>
              <v-icon class="p-accountIcon__img" color="grey">
                mdi-account
              </v-icon>
            </div>
          </div>
        </template>

        <v-card>
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  currentUserAuth.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list dense>
            <router-link to="/master_writer/profiles">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>プロフィール設定</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </router-link>
            <router-link to="/master_writer/emails">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>メールアドレス変更</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </router-link>
          </v-list>
          <v-card-actions>
            <LogoutBtn />
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import LogoutBtn from '@/components/commons/LogoutBtn'
import Logo from '/static/service/master_logo.svg'

export default {
  components: { LogoutBtn },
  data: () => ({
    accountMenu: false,
    globalMenuItems: [
      {
        icon: 'mdi-clipboard-text-multiple',
        text: '応募する',
        router: { name: 'masterWriterOrderBoard' }
      },
      {
        icon: 'mdi-pencil',
        text: '執筆する',
        router: { name: 'masterWriterPosts' }
      },
      {
        icon: 'mdi-account',
        text: 'ユーザー',
        router: { name: 'masterWriterUsers' }
      }
    ]
  }),
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    })
  },
  methods: {
    logoSrc () {
      return Logo
    }
  }
}
</script>

<style scoped lang="sass">
.l-mainHeader
  position: fixed
  border-bottom: 1px solid #BEBEBE
  background: #fff
  height: 60px
  display: flex
  justify-content: space-between
  width: 100%
  z-index: 99
  &__leftWrapper
    height: 100%
    display: flex
  &__rightWrapper
    width: 150px
    height: 100%
    display: flex
    justify-content: center
    align-items: center
  &__gMenuWrapper
    min-width: 600px
    margin-left: 100px
    height: 60px
    display: flex
  &__gMenuItem
    a
      margin-top: 10px
      margin-left: 30px
      line-height: 48px
      display: block
      color: #6D6D6D
      padding: 0 8px
      span
        font-size: 1rem
        margin-left: 5px
        line-height: 48px
    .active
      position: relative
      display: block
      color: #315ED9
      font-weight: 500
      box-sizing: border-box
      border-bottom: 3px solid #315ED9
      .v-icon
        color: #315ED9
  &__serviceLogoWrapper
    height: 50px
    width: 150px
    padding-top: 10px
    padding-left: 20px
    padding-bottom: 15px
  &__serviceLogo
    display: block
    margin: 0 auto
    width: 100%
.p-accountIcon
  vertical-align: middle
  &__img
    display: block
    border: 2px solid #D3D3D3
    border-radius: 50%
    height: 40px
    width: 40px
    &:hover
      cursor: pointer
.accountMenu
  z-index: 999
</style>
